import React from 'react';
import {
  Avatar,
  Box,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
} from '@chakra-ui/react';
import { useAuth } from 'contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import { MdPayment } from 'react-icons/md';

export default function UserProfileTile() {
  const { signOut, userData } = useAuth();
  const navigate = useNavigate();
  const { colorMode, toggleColorMode } = useColorMode();
  
  const displayName = userData?.displayName || (userData?.email ? userData.email.split('@')[0] : 'User');
  const avatarSrc = userData?.photoURL || undefined;
  
  const bgColor = useColorModeValue('white', 'navy.700');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = useColorModeValue('gray.600', 'gray.400');
  const menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const iconColor = useColorModeValue('gray.400', 'white');
  
  return (
    <Flex
      direction="row"
      align="center"
      gap="8px"
      mt="auto"
      pt="20px"
      pb="40px"
      pr="12px"
      borderTop="1px solid"
      borderColor={borderColor}
    >
      <>
        <Menu>
          <MenuButton
            as={Button}
            variant="no-hover"
            bg="transparent"
            p="12px"
            borderRadius="12px"
            _hover={{ bg: useColorModeValue('gray.50', 'whiteAlpha.100') }}
            _active={{ bg: useColorModeValue('gray.100', 'whiteAlpha.200') }}
            flex="1"
          >
            <Flex align="center" gap="10px">
              <Avatar
                name={displayName}
                src={avatarSrc}
                bg="#11047A"
                color="white"
                size="sm"
                w="40px"
                h="40px"
              />
              <Box textAlign="left">
                <Text fontSize="sm" fontWeight="700" color={textColor}>
                  {displayName}
                </Text>
                <Text fontSize="xs" color={textColorSecondary}>
                  {userData?.email || ''}
                </Text>
              </Box>
            </Flex>
          </MenuButton>
          <MenuList
            boxShadow={shadow}
            p="0px"
            mb="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
          >
            <Flex w="100%" mb="0px">
              <Text
                ps="20px"
                pt="16px"
                pb="10px"
                w="100%"
                borderBottom="1px solid"
                borderColor={borderColor}
                fontSize="sm"
                fontWeight="700"
                color={textColor}
              >
                👋  Hey, {displayName}
              </Text>
            </Flex>
            <Flex flexDirection="column" p="10px">
              <MenuItem
                bg="transparent"
                _hover={{ bg: useColorModeValue('gray.50', 'whiteAlpha.100') }}
                _focus={{ bg: 'transparent' }}
                borderRadius="8px"
                px="14px"
                py="10px"
                onClick={toggleColorMode}
              >
                <Flex align="center" gap="10px">
                  <Icon
                    h="18px"
                    w="18px"
                    color={iconColor}
                    as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
                  />
                  <Text fontSize="sm">
                    {colorMode === 'light' ? 'Dark Mode' : 'Light Mode'}
                  </Text>
                </Flex>
              </MenuItem>
              <MenuItem
                bg="transparent"
                _hover={{ bg: useColorModeValue('gray.50', 'whiteAlpha.100') }}
                _focus={{ bg: 'transparent' }}
                borderRadius="8px"
                px="14px"
                py="10px"
                onClick={() => navigate('/admin/subscriptions')}
              >
                <Flex align="center" gap="10px">
                  <Icon
                    h="18px"
                    w="18px"
                    color={iconColor}
                    as={MdPayment}
                  />
                  <Text fontSize="sm">Subscriptions</Text>
                </Flex>
              </MenuItem>
              <MenuItem
                bg="transparent"
                _hover={{ bg: useColorModeValue('red.50', 'whiteAlpha.100') }}
                _focus={{ bg: 'transparent' }}
                color="red.400"
                borderRadius="8px"
                px="14px"
                py="10px"
                onClick={async () => {
                  await signOut();
                  navigate('/auth/sign-in');
                }}
              >
                <Text fontSize="sm">Log out</Text>
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </>
    </Flex>
  );
}

